import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from 'formik';
import { Box, Button, Container, TextField, Autocomplete, Switch } from "@mui/material";
import { CustomNumberInput, NumberInputButton } from '../../components';
import UserService from '../../services/user';
import { TYPE_MOVEMENT } from '../../helpers/enums';
import { DEFAULT_STORE, ccyFormat } from '../../helpers/helper';
import { FromMovimientoSkeleton } from '../../components/skeletons';

const formSchema = Yup.object().shape({
  typeMovement: Yup.string().required("Campo Requerido"),
  description: Yup.string(),
  amount: Yup.string().when(
    'typeMovement', {
      is: TYPE_MOVEMENT.INVERSION,
      then: () => Yup.number().moreThan(0, 'Campo debe ser mayor a 0'),
      otherwise: () => Yup.number().required("Campo Requerido")
    }
  ),
  userName: Yup.string().when(
    'typeMovement', {
      is: TYPE_MOVEMENT.REINVERSION,
      then: () => Yup.string(),
      otherwise: () => Yup.string().required("Campo Requerido")
    }
  ),
  investment: Yup.number()
    .when(
      'typeMovement', {
        is: (val) => val === TYPE_MOVEMENT.REINVERSION || val === TYPE_MOVEMENT.GANANCIAS,
        then: () => Yup.number()
          .test(
            'investment-test',
            'El investment debe ser mayor que el amount',
            function (value) {
              const { amount } = this.parent;
              return value >= amount;
            }
          ),
        otherwise: () => Yup.number()
      }
    ),
})

const FormMovimiento = ({ onClose, onSubmit, saving = false, investmentAmount, dineroDisponible }) => {
  const [users, setUsers] = useState([])
  const [type, setType] = useState(TYPE_MOVEMENT.REINVERSION)
  const getOptions = () => Object.values(TYPE_MOVEMENT).filter(type => type !== TYPE_MOVEMENT.DINERO_DISPONIBLE && type !== TYPE_MOVEMENT.DINERO_DISPONIBLE_PARA_REINVERSION).map(type => ({name: type}))

  let initialValues = {
    userName: '',
    typeMovement: '',
    description: '',
    amount: 0,
    investment: type === TYPE_MOVEMENT.REINVERSION ? investmentAmount : dineroDisponible
  }

  const loadUsers = async () => {
    var resp = await UserService.getAll()
    setUsers(resp)
  }

  useEffect(() => {
    if(users.length === 0) {
      loadUsers()
    }
  }, [])

  const handleSubmitForm = async (data) => {
    if (onSubmit) {
      data.userName = data?.userName !== '' ? data.userName : DEFAULT_STORE 
      onSubmit(data)
    }
  }

  const { handleChange, handleSubmit, setFieldValue, values, errors, isValid } = useFormik({
    initialValues,
    onSubmit: handleSubmitForm,
    validationSchema: formSchema,
  })

  const { userName, typeMovement, description, amount, investment } = values

  return <Box
    component="form"
    onSubmit={handleSubmit}
    padding={3}
  >
    {saving ? <FromMovimientoSkeleton /> :
    <Box>
      <Box display='flex' flexDirection='row' justifyContent="space-between" marginY={1}>
      <strong>Nuevo Movimiento</strong>
      </Box >
      <Autocomplete
        options={getOptions()}
        getOptionLabel={option => option.name}
        clearOnEscape
        sx={{ marginY: 2 }}
        onChange={(event, newValue) => {
            setFieldValue('typeMovement', newValue?.name || null);
            setType(newValue)
            setFieldValue('investment', TYPE_MOVEMENT.REINVERSION === newValue.name ? investmentAmount : dineroDisponible );
        }}
        renderInput={(params) => (
            <TextField
              {...params}
              id="type_movement"
              label="Tipo Mov."
              type="text"
              variant="standard"
              error={errors.typeMovement}
              helperText={errors.typeMovement}
              value={typeMovement}
            />
        )}
      />
      {typeMovement !== '' && typeMovement !== TYPE_MOVEMENT.REINVERSION &&
        <Autocomplete
          options={users}
          getOptionLabel={user => user.name}
          clearOnEscape
          sx={{ marginY: 2 }}
          onChange={(event, newValue) => {
              setFieldValue('userName', newValue?.name || null);
          }}
          renderInput={(params) => (
              <TextField
              {...params}
              id="user_name"
              label="Usuario"
              type="text"
              variant="standard"
              error={errors.userName}
              helperText={errors.userName}
              value={userName}
              />
          )}
        />
      }
      {typeMovement !== '' && (typeMovement === TYPE_MOVEMENT.REINVERSION || typeMovement === TYPE_MOVEMENT.GANANCIAS) &&
      <TextField
        id="investment"
        label="Dinero disponible"
        type="text"
        variant="standard"
        disabled
        // sx={{ mt: 2, margin: 'auto' }}
        fullWidth
        error={errors.investment}
        helperText={errors.investment}
        //name="name"
        value={investment}
        onChange={handleChange}
      />}
      <br></br>
      <br></br>
      <TextField
        id="description"
        label="Descripcion"
        type="text"
        variant="outlined"
        fullWidth
        error={errors.description}
        helperText={errors.description}
        value={description}
        onChange={handleChange}
      />
      <Box display='flex' flexDirection='row' gap={2} marginY={1}>
      <CustomNumberInput
          id="amount"
          label='Cantidad'
          labelText='Monto'
          value={amount}
          onChange={(event, newValue) => {
            event.preventDefault();
            setFieldValue('amount', newValue);
          }}
      />
      </Box>
    </Box>}
    <Box sx={{ mt: 5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Button
        type="submit"
        variant="outlined"
        onClick={onClose}
        disabled={saving}
      >Cancelar</Button>
      <Button
        type="submit"
        variant="outlined"
        disabled={!isValid || saving}
      >Guardar</Button>
    </Box>
    {/* <Modal open={openModal} onClose={() => setOpenModal(false)} Content={() => <FormPrecio onClose={() => setOpenModal(false)} prices={prices} onChange={(field, newValue) => {
      setFieldValue(field, newValue);
    }} />} /> */}
  </Box>
}

export default FormMovimiento;